import { useEffect } from "react";
import { useData } from "../hooks/useData";

// Applies white-label branding from site.json at runtime:
// brand colors (CSS vars), favicon and document title. No code changes needed
// to rebrand — edit site.json only.
export default function BrandProvider({ children }) {
  const { data: site } = useData("site");

  useEffect(() => {
    if (!site) return;
    const root = document.documentElement;
    if (site.primaryColor) root.style.setProperty("--brand", site.primaryColor);
    if (site.secondaryColor) root.style.setProperty("--brand-2", site.secondaryColor);

    if (site.favicon) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = site.favicon;
    }
    if (site.seo?.title) document.title = site.seo.title;
  }, [site]);

  return children;
}
